import { Injectable } from '@angular/core';

@Injectable()
export class CustomPubSub {

    subscriptions;

    constructor() {
        this.subscriptions = {};
    }

    registerEvents(evts) {
        for (let i = 0; i < evts.length; i++) {
            this.subscriptions[evts[i]] = [];
        }
    }

    publish(evt, params) {
        let handlers = this.subscriptions[evt];
        if (handlers && handlers.length) {
            for (let i = 0; i < handlers.length; i++) {
                handlers[i]({ type: evt }, params);
            }
        }
    }

    subscribe(evt, handler) {
        if (this.subscriptions[evt]) {
            this.subscriptions[evt].push(handler);
        }
    }

    unsubscribe(evt, handler) {
        let handlers = this.subscriptions[evt];
        if (handlers && (handlers.indexOf(handler) >= 0)) {
            handlers.splice(handlers.indexOf(handler), 1);
        }
    }

}